/*
 * /journal/[slug] (page)
 */
import { createFileRoute } from "@tanstack/react-router"
import {
	Container,
	Divider,
	Page,
	PageHeader,
	Skeleton,
} from "@psychology/react-ui"
import { capitalizeFirstLetter } from "@psychology/utils"
import { ArrowLeft } from "lucide-react"
import { JournalEntryForm } from "../../features/journal/components/journal-entry-form"
import { trpc } from "../../trpc"
import { authPageLoader } from "../../utils/auth.utils"

export const Route = createFileRoute("/journal/$journalEntryId")({
	component: JournalEntryPage,
	loader: authPageLoader,
})

function JournalEntryPage() {
	const { journalEntryId } = Route.useParams()
	const { user } = Route.useLoaderData()

	const { data: journalEntry, isLoading } =
		trpc.journalEntry.getByFilter.useQuery({
			where: { id: journalEntryId },
		})

	if (isLoading) {
		return (
			<Page centerVertical={false}>
				<Container
					className={"items-center"}
					width={"xl"}
					padding={"lg"}
					gap={"sm"}
				>
					<Skeleton className={"h-8 w-64"} />
					<Divider />
					<div
						className={
							"flex w-full flex-col items-center justify-center gap-3 py-6"
						}
					>
						<Skeleton className={"h-10 w-full max-w-[500px]"} />
						<Skeleton className={"h-10 w-full max-w-[500px]"} />
						<Skeleton className={"h-10 w-full max-w-[500px]"} />
						<Skeleton className={"h-[200px] w-full"} />
					</div>
				</Container>
			</Page>
		)
	}

	return (
		<Page centerVertical={false}>
			<Container
				className={"items-center"}
				width={"xl"}
				padding={"lg"}
				gap={"sm"}
			>
				<PageHeader
					title={capitalizeFirstLetter(
						journalEntry?.title || "New Journal Entry",
						true,
					)}
					left={{
						href: "/journal",
						label: "Back",
						Icon: <ArrowLeft size={20} />,
					}}
				/>
				<Divider />
				<div className={"w-full py-6"}>
					<JournalEntryForm
						id={journalEntryId}
						journalEntry={journalEntry || undefined}
						user={user}
					/>
				</div>
			</Container>
		</Page>
	)
}
